import React, { type FC, useState } from 'react';

import { Box, Text } from '@clutter/clean';

import { useTrack } from '@root/initializers/wt';

import { Block, BlockProps } from '@shared/page_builder/block';
import { HoardersCard } from '@shared/partnerships/hoarders_card';
import { HonestRenovationsCard } from '@shared/partnerships/honest_renovations_card';
import { InstantDreamHomeCard } from '@shared/partnerships/intant_dream_home_card';
import { RachaelRayShowCard } from '@shared/partnerships/rachael_ray_show_card';
import { SwedishDeathCleaningCard } from '@shared/partnerships/swedish_death_cleaning_card';
import { TabContainer } from '@shared/tab_container';
import { TabItem } from '@shared/tab_item';

type Partnership = {
  name: string;
  Component: FC;
};

const PARTNERSHIPS: Partnership[] = [
  {
    name: 'Netflix',
    Component: InstantDreamHomeCard,
  },
  {
    name: 'Jessica Alba',
    Component: HonestRenovationsCard,
  },
  {
    name: 'Amy Poehler',
    Component: SwedishDeathCleaningCard,
  },
  {
    name: 'Rachael Ray',
    Component: RachaelRayShowCard,
  },
  {
    name: 'Hoarders',
    Component: HoardersCard,
  },
];

export const SocialProof = (blockProps: BlockProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const track = useTrack({
    container: 'social_proof',
  });

  const { Component } = PARTNERSHIPS[activeTabIndex];
  return (
    <Block {...blockProps}>
      <Text.Title size="large">
        Trusted by people and brands you know and love...
      </Text.Title>
      <Box margin={['32px 0 24px', '48px 0 40px']}>
        <TabContainer>
          {PARTNERSHIPS.map((partnership, index) => (
            <TabItem
              key={index}
              name={partnership.name}
              active={activeTabIndex === index}
              onClick={() => {
                track({
                  action: 'click',
                  objectType: 'tab',
                  label: partnership.name,
                });
                setActiveTabIndex(index);
              }}
            />
          ))}
        </TabContainer>
      </Box>
      <Component />
    </Block>
  );
};
